import React, { useMemo, useState } from 'react';

const BuiltInVariables = ({ variables, searchQuery }) => {
  const [copiedVar, setCopiedVar] = useState(null);

  // Filter variables by search
  const filteredVariables = useMemo(() => {
    if (!variables || variables.length === 0) return [];
    if (!searchQuery.trim()) return variables;

    const query = searchQuery.toLowerCase();
    return variables.filter(v => 
      v.name.toLowerCase().includes(query) ||
      (v.description && v.description.toLowerCase().includes(query)) ||
      (v.type && v.type.toLowerCase().includes(query))
    );
  }, [variables, searchQuery]);

  const handleCopyVariable = (varName) => {
    // Copy with braces if not already present
    const toCopy = varName.startsWith('{') ? varName : `{${varName}}`;
    navigator.clipboard.writeText(toCopy).then(() => {
      setCopiedVar(varName);
      setTimeout(() => setCopiedVar(null), 2000);
    });
  };

  const getTypeColor = (type) => {
    if (!type) return '#6b7280';
    const typeLower = type.toLowerCase();
    if (typeLower.includes('string')) return '#10b981';
    if (typeLower.includes('number') || typeLower.includes('int')) return '#3b82f6';
    if (typeLower.includes('boolean')) return '#f59e0b';
    if (typeLower.includes('array') || typeLower.includes('list')) return '#8b5cf6';
    return '#6b7280';
  };

  return (
    <div className="baiql-builtin-variables">
      <div className="baiql-builtin-variables-header">
        <h3>Built-in Variables</h3>
        <p>Click any variable to copy with braces</p>
      </div>


      <div className="baiql-builtin-variables-list">
        {filteredVariables.length === 0 ? (
          <div className="baiql-builtin-variables-empty">
            <p>No variables found{searchQuery ? ` matching "${searchQuery}"` : ''}.</p>
          </div>
        ) : (
          filteredVariables.map((variable) => {
            const varName = variable.name || '';
            const displayName = varName.startsWith('{') ? varName : `{${varName}}`;
            const isCopied = copiedVar === varName;

            return (
              <button
                key={varName}
                className={`baiql-builtin-variable-item ${isCopied ? 'copied' : ''}`}
                onClick={() => handleCopyVariable(varName)}
                title="Click to copy"
              >
                <div className="baiql-builtin-variable-header">
                  <code className="baiql-builtin-variable-name">{displayName}</code>
                  {variable.type && (
                    <span
                      className="baiql-builtin-variable-type"
                      style={{ backgroundColor: getTypeColor(variable.type) }}
                    >
                      {variable.type}
                    </span>
                  )}
                </div>
                {variable.description && (
                  <div className="baiql-builtin-variable-desc">
                    {variable.description}
                  </div>
                )}
                {isCopied && (
                  <div className="baiql-builtin-variable-copied">✓ Copied!</div>
                )}
              </button>
            );
          })
        )}
      </div>
    </div>
  );
};

export default BuiltInVariables;

